import { Check, ChevronDown, SquareCheck } from 'lucide-react';
import { cn } from '@/ui/design-system/utils/cn';
import {
    Button,
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuTrigger,
} from '@/ui/design-system/components';
import type { EntityListSeries } from './entityListModel';

const ListLegendDropdown = ({
    series,
    hiddenIds,
    onToggle,
    preserveNameCase,
}: {
    series: EntityListSeries[];
    hiddenIds: Set<string>;
    onToggle: (id: string, visible: boolean) => void;
    preserveNameCase?: boolean;
}) => (
    <DropdownMenu>
        <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm">
                <SquareCheck />
                List
                <ChevronDown />
            </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
            <div className="max-h-64 overflow-y-auto">
                {series.map((s) => {
                    const visible = !hiddenIds.has(s.id);
                    return (
                        <DropdownMenuCheckboxItem
                            key={s.id}
                            // Hides the DS item's built-in indicator (its first
                            // span); the span below draws the checkbox instead.
                            className="gap-2 pl-2 text-xs [&>span:first-child]:hidden"
                            checked={visible}
                            onCheckedChange={(checked: boolean) =>
                                onToggle(s.id, checked)
                            }
                            onSelect={(e: Event) => e.preventDefault()}
                        >
                            {/* Not the DS Checkbox: it is a <button>, illegal
                                inside a menuitemcheckbox. */}
                            <span
                                aria-hidden
                                className={cn(
                                    'grid h-4 w-4 shrink-0 place-content-center rounded-sm border border-primary shadow',
                                    visible &&
                                        'bg-primary text-primary-foreground',
                                )}
                            >
                                {visible && <Check className="h-3 w-3" />}
                            </span>
                            <span
                                className={`flex-1 truncate ${
                                    preserveNameCase ? '' : 'capitalize'
                                }`}
                            >
                                {s.name}
                            </span>
                            <span
                                className="size-1.5 shrink-0 rounded-full"
                                style={{ backgroundColor: s.color }}
                            />
                        </DropdownMenuCheckboxItem>
                    );
                })}
            </div>
        </DropdownMenuContent>
    </DropdownMenu>
);

export default ListLegendDropdown;
